import { ModalElement } from '@/components/custom-elements/modal'

type BrowsingContextSuggestionsResponse = {
  detected_values: {
    country_name: string
    country: {
      handle: string
      name: string
    }
  }
  features: Record<string, unknown>
  suggestions: []
}

class LocalizationForm extends HTMLElement {
  elements: {
    input: HTMLInputElement | null
    search: HTMLInputElement | null
    list: HTMLElement | null
    modal: ModalElement | null
    currentCountry: HTMLElement | null
    modalMessage: HTMLElement | null
  }

  selectors = {
    name: 'data-name',
    value: 'data-value'
  }

  constructor() {
    super()
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      search: this.querySelector('#CountrySearch'),
      list: this.querySelector('#CountryList'),
      modal: document.querySelector('[data-id="localization"]'),
      currentCountry: document.querySelector('#current-country'),
      modalMessage: document.querySelector('#localization-modal-message')
    }
  }

  connectedCallback() {
    this.fetchElements()
    this.addEventListeners()
    this.getCurrentCountry()
  }

  fetchElements() {
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      search: this.querySelector('#CountrySearch'),
      list: this.querySelector('#CountryList'),
      modal: document.querySelector('[data-id="localization"]'),
      currentCountry: document.querySelector('#current-country'),
      modalMessage: document.querySelector('#localization-modal-message')
    }
  }

  addEventListeners() {
    this.elements.search?.addEventListener('input', this.onSearchInput.bind(this))
    this.querySelectorAll('a[data-value]').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    )
  }

  onSearchInput(event: Event) {
    event.preventDefault()
    const currentTarget = event.currentTarget as HTMLInputElement
    const value = currentTarget?.value?.toLowerCase()
    this.elements?.list?.querySelectorAll('a').forEach((item) => {
      const name = item.getAttribute(this.selectors.name)?.toLowerCase()
      const itemValue = item.getAttribute(this.selectors.value)?.toLowerCase()
      const wrappingListItem = item.closest('li')
      if (!wrappingListItem) return
      if (name?.includes(value) || itemValue?.includes(value)) wrappingListItem.style.display = 'block'
      else wrappingListItem.style.display = 'none'
    })
  }

  onItemClick(event: Event) {
    event.preventDefault()
    const form = this.querySelector('form')
    const target = event.target as HTMLElement
    const dataElement = target.closest('[data-value]') as HTMLElement | null

    if (!this.elements.input || !dataElement?.dataset.value) return
    this.elements.input.value = dataElement.dataset.value
    if (form) form.submit()
  }

  async getCurrentCountry() {
    if (!window.Shopify) return
    const response: BrowsingContextSuggestionsResponse = await fetch(
      window.Shopify.routes.root + 'browsing_context_suggestions.json'
    ).then((r) => r.json())
    const currentCountry = window.Shopify.country
    const countryHandle = response.detected_values.country.handle
    const countries = window.globals?.metaobjects?.countries || []
    const matchingCountry = countries.find((country) => {
      const [, countryCode] = country.hreflang.split('-')
      return countryCode.toLowerCase() === countryHandle.toLowerCase()
    })
    const matchingCountryCode = matchingCountry?.hreflang.split('-')[1]
    if (matchingCountryCode?.toLowerCase() === currentCountry?.toLowerCase()) return
    if (sessionStorage.getItem('localization-modal-shown')) return
    if (matchingCountry?.url) {
      console.log('matchingCountry', matchingCountry)
      this.elements.modal?.handleShow()
      this.elements.modalMessage?.classList.remove('hidden')
      sessionStorage.setItem('localization-modal-shown', 'true')
    }
  }
}

customElements.define('localization-form', LocalizationForm)
